export default __webpack_public_path__ + "static/media/thumbnail.02741b48.png";